import Logger from '../logger';
import event from '../mixins/event';
import KrempRules from './krempRules';

class ZipInCal {

	// Vars
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

	/**
	 * Class constructor
	 */
	constructor(dom) {

		this.NAME = 'ZipInCal';

		this.dom = dom;

		this.calendarInputArea = this.dom.querySelector('[data-calendar-input-area]');
		this.calendarPreviewArea = this.dom.querySelector('[data-calendar-preview-area]');
		this.calendarCodeEditAction = this.dom.querySelector('[data-calendar-edit-action]');

		this.flatpickrDisabledDates = [];
		this.flatpickrEnabledDates = [];
		this.flatpickrFlexDates = [];
		this.flatpickrInput = null;
		this.flatpickrSundays = false;

		this.flexHolidayTooltipText = null;

		this.holidaysArray = [];

		this.deliverySeasons = [];

		this.actionMessageDoms = document.querySelectorAll(`[data-action-messages]`);
		this.datePickerMessageDoms = document.querySelectorAll('[data-datepicker-messages]');
		this.zipCodeMsgDoms = document.querySelectorAll('[data-zip-code-messages]');

		this.purchaseButtonDoms = document.querySelectorAll('[name="add"]');

		this.savedZipCode = localStorage.getItem('zipCode');
		this.savedDeliveryDate = localStorage.getItem('deliveryDate');

		this.currentPrice = null;

		this.zipCodeInputArea = this.dom.querySelector('[data-zip-code-input-area]');
		this.zipCodePreviewArea = this.dom.querySelector('[data-zip-code-preview-area]');
		this.zipCodeInput = this.dom.querySelector('#zipCodeInput');
		this.zipCodeSelectedPreview = this.dom.querySelector('[data-zip-code-selected]');
		this.zipCodeEditAction = this.dom.querySelector('[data-zip-code-edit-action]');
		this.zipForm = document.getElementById('zipForm');

		this.selected_holiday = this.dom.getElementsByClassName('flatpickr-day selected flex-holiday');

		this.rulesPayload = KrempRules.getRulesForPageByZipCode(window.pdpZipCodeRules, this.savedZipCode);
	}

	/**
	 * init - Initialize the form
	 */
	init() {
		Logger.info(`${this.NAME} > init`);

		const self = this;

		this.initFlatpickr();

		// Check and pre-populate the fields from localStorage

		// CLick to edit Zip Code
		this.zipCodeEditAction.addEventListener('click', function (e) {
			e.preventDefault();
			self.showZipCodeInputArea();
		});

		// Click to edit Calendar
		this.calendarCodeEditAction.addEventListener('click', function (e) {
			e.preventDefault();
			self.showCalendarInputArea();
		});

		// Check if zip code is saved
		if (this.savedZipCode) {
			this.zipCodeInput.value = this.savedZipCode; // Pre-populate zip code
			this.zipCodeSelectedPreview.innerText = this.savedZipCode;
			this.showZipCodePreviewArea();
			this.setCalendarDays();
			this.updateAllStatusMessages();
		}


		// Check if delivery date is saved
		if (this.savedDeliveryDate && this.isValidDate(this.savedDeliveryDate)) {
			this.flatpickrInput.setDate(this.savedDeliveryDate); // Pre-populate flatpickr with saved date
			this.updateAllStatusMessages();
			this.showCalendarPreviewArea();
		} else {
			this.setSelectedDate(false);
		}

		// Form submission for Zip Code
		this.zipForm.addEventListener('submit', function (event) {
			event.preventDefault(); // Prevent form from submitting normally

			const zipCodeValue = self.zipCodeInput.value;

			// Save zip code to localStorage
			if (zipCodeValue.length > 3) {
				self.savedZipCode = zipCodeValue;
				localStorage.setItem('zipCode', zipCodeValue);
				self.zipCodeSelectedPreview.innerText = zipCodeValue;
				self.showZipCodePreviewArea();
				self.rulesPayload = KrempRules.getRulesForPageByZipCode(window.pdpZipCodeRules, zipCodeValue);
				self.setCalendarDays();
				self.updateAllStatusMessages();
			} else {
				alert('Please enter a valid zip code');
			}
		});

		// Listen for on:price:update event on document
		document.addEventListener('on:price:update', function (e) {
			self.currentPrice = e.detail.variant.price;
			self.setCalendarDays();
			self.enforcePurchasability(true);
			self.updateAllStatusMessages();
		});

		this.enforcePurchasability(true);

		// Re-enforce purchasability every second
		setInterval(() => {
			this.enforcePurchasability();
		}, 1000);

		// Listen for on:date:update event on document
		this.on('on:date:update', function (e) {
			self.setCalendarDays();
			self.enforcePurchasability(true);
			if (self.savedDeliveryDate) {
				self.showCalendarPreviewArea();
			} else {
				self.showCalendarInputArea();
			}
		});
	}

	clearActionMessages() {
		this.actionMessageDoms.forEach((dom) => {
			dom.innerHTML = '';
		});
	}

	clearDatePickerMessages() {
		this.datePickerMessageDoms.forEach((dom) => {
			dom.innerHTML = '';
		});
	}

	clearZipCodeMessages() {
		this.zipCodeMsgDoms.forEach((dom) => {
			dom.innerHTML = '';
		});
	}

	/**
	 * compareMilitaryTimes - Compare two military times
	*/
	compareMilitaryTimes(time1, time2) {

		// Convert times to minutes
		const time1Minutes = parseInt(time1.slice(0, 2)) * 60 + parseInt(time1.slice(2));
		const time2Minutes = parseInt(time2.slice(0, 2)) * 60 + parseInt(time2.slice(2));

		if (time1Minutes < time2Minutes) {
			return -1; // time1 is earlier
		} else if (time1Minutes > time2Minutes) {
			return 1; // time1 is later
		} else {
			return 0; // times are equal
		}
	}

	disablePurchaseButtons() {
		// Logger.info(`${this.NAME} > disablePurchaseButtons`);

		// Disable purchase buttons
		for (const button of this.purchaseButtonDoms) {
			button.disabled = true;
		}
	}

	displayFlexShippingSelectedMessage() {
		this.setDatePickerMessage("You've selected a <a href='#'>flex holiday shipping date.</a>");
	}

	enablePurchaseButtons() {
		// Logger.info(`${this.NAME} > enablePurchaseButtons`);

		// Enable purchase buttons
		for (const button of this.purchaseButtonDoms) {
			button.disabled = false;
		}
	}

	enforcePurchasability(showLogs) {
		if (showLogs) Logger.info(`${this.NAME} > enforcePurchasability`);

		// Check if a zip code is selected
		if (!this.savedZipCode) {
			if (showLogs) Logger.info(`${this.NAME} > enforcePurchasability > No zip code selected`);
			this.disablePurchaseButtons();
			return;
		}

		// Check if a delivery date is selected
		if (!this.savedDeliveryDate) {
			if (showLogs) Logger.info(`${this.NAME} > enforcePurchasability > No delivery date selected`);
			this.disablePurchaseButtons();
			return;
		}

		// Figs, exclusive and direct floral cannot go international
		const productShippingType = window.product_shipping_type ? window.product_shipping_type : null;
		if (productShippingType === 'Figs' || productShippingType === 'Exclusive' || productShippingType === 'Direct Floral') {
			if (this.savedZipCode && !KrempRules.zipCodeIsDomestic(this.savedZipCode)) {
				if (showLogs) Logger.info(`${this.NAME} > enforcePurchasability > Figs, exclusive and direct floral cannot ship international`);
				this.disablePurchaseButtons();
				return;
			}
		}

		// If it is after the cutoff time for the selected date, disable purchase buttons
		if (this.rulesPayload) {
			for (const item of this.rulesPayload.rules) {
				if (item.type === 'shipping cutoff') {

					const isAfterCuttof = KrempRules.isAfterCutOffTimeInZipCode(this.savedZipCode, this.savedDeliveryDate, item.time);

					// If the rule has "unavailable same day"
					// If it does, we need to disable today no matter what, and if the cutoff time has passed, disable tomorrow
					if (item.same_day_unavailable === "true") {

						// Check if this.saveDeliveryDate is today
						const today = new Date();
						const todayStr = today.toISOString().slice(0, 10);
						if (this.savedDeliveryDate === todayStr) {
							if (showLogs) Logger.info(`${this.NAME} > enforcePurchasability > Same day delivery is unavailable`);
							this.disablePurchaseButtons();
							return;
						}

						// If the cutoff time has passed, disable tomorrow
						if (isAfterCuttof) {
							let tomorrow = new Date(today);
							tomorrow.setDate(today.getDate() + 1);
							if (this.savedDeliveryDate === tomorrow.toISOString().slice(0, 10)) {
								if (showLogs) Logger.info(`${this.NAME} > enforcePurchasability > Cutoff time has passed for tomorrow`);
								this.disablePurchaseButtons();
								return;
							}
						}

						// Otherwise, we only need to disable today if the cutoff time has passed for today
					} else {
						if (isAfterCuttof) {
							if (showLogs) Logger.info(`${this.NAME} > enforcePurchasability > Cutoff time has passed`);
							this.disablePurchaseButtons();
							return;
						}
					}
				}

				// Is the selected date a Sunday?
				if (item.type === 'disabled sunday' && this.savedZipCode) {
					const dateObjInZip = KrempRules.getDateObjectForZipCode(this.savedZipCode, this.savedDeliveryDate);
					if (dateObjInZip && dateObjInZip.getDay() === 0) {
						if (showLogs) Logger.info(`${this.NAME} > enforcePurchasability > Selected date is a Sunday`);
						this.disablePurchaseButtons();
						return;
					}
				}
			}
		}

		// If this product is available in specific seasons, check if the selected date is in one of those seasons
		if (this.deliverySeasons.length) {

			// Check if the selected date is in one of the delivery seasons
			let selectedDateIsInSeason = false;
			for (let s in this.deliverySeasons) {
				const season = this.deliverySeasons[s];

				// Get date object for the selected date
				const selectedDate = new Date(this.savedDeliveryDate);

				// Get date objects for the start and end of the season
				const seasonStartDate = new Date(season.start_date);
				const seasonEndDate = new Date(season.end_date);

				// Check if the selected date is in the season
				if (selectedDate >= seasonStartDate && selectedDate <= seasonEndDate) {
					selectedDateIsInSeason = true;
					break;
				}
			}

			if (!selectedDateIsInSeason) {
				if (showLogs) Logger.info(`${this.NAME} > enforcePurchasability > Selected date is not in a delivery season`);
				this.disablePurchaseButtons();
				return;
			}
		}

		this.enablePurchaseButtons();
	}

	/**
	 * generateDateRange - Generate a date range
	 * @param {string} startDate - The start date
	 * @param {string} endDate - The end date
	 * @returns {array} - The date range
	 */
	generateDateRange(startDate, endDate) {
		Logger.info(`${this.NAME} > generateDateRange`);

		const start = new Date(startDate);
		const end = new Date(endDate);
		const dateArray = [];

		let currentDate = start;

		while (currentDate <= end) {
			const year = currentDate.getFullYear();
			const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Months are 0-based
			const day = String(currentDate.getDate()).padStart(2, '0');
			dateArray.push(`${year}-${month}-${day}`);

			// Move to the next day
			currentDate.setDate(currentDate.getDate() + 1);
		}

		return dateArray;
	}

	/**
	 * getCurrentMilitaryTime - Get the current time in military format
	 */
	getCurrentMilitaryTime() {
		// Get current time
		var currentDate = new Date();
		// Get hours and minutes
		var hours = currentDate.getHours();
		var minutes = currentDate.getMinutes();
		// Format minutes to always be two digits (e.g., "04" instead of "4")
		minutes = minutes < 10 ? '0' + minutes : minutes;
		// Military time format (24-hour time)
		var militaryTime = String(hours) + String(minutes);
		return militaryTime;
	}

	/**
	 * getFlexSettingsForDateObj - Check if there is a flex holiday for the provided date object
	 * @param {object} dateObj - The date object
	 * @returns {boolean} - True if the date is in the flex range
	 * @returns {boolean} - False if the date is not in the flex range
	 */
	getFlexSettingsForDateObj(dateObj) {
		Logger.info(`${this.NAME} > getFlexSettingsForDateObj`);
		// if (!dateObj || (dateObj instanceof Date && !isNaN(dateObj))) return;

		// Loop through the flex dates and check if obj.date is the provided date

		// Get date string from date of YYYY-MM-DD
		const dateStr = dateObj.toISOString().slice(0, 10);
		for (const flexDate of this.flatpickrFlexDates) {
			if (flexDate.date === dateStr) {
				return flexDate;
			}
		}

		return false;
	}

	/**
	 * getListOfAppliedRuleMessages - Get a list of applied rule messages
	 * @returns {array} - The list of messages
	 */
	getListOfAppliedRuleMessages() {
		const messages = [];

		// Figs, exclusive and direct floral cannot go international
		const productShippingType = window.product_shipping_type ? window.product_shipping_type : null;
		if (productShippingType === 'Figs' || productShippingType === 'Exclusive' || productShippingType === 'Direct Floral') {
			if (this.savedZipCode && !KrempRules.zipCodeIsDomestic(this.savedZipCode)) {
				messages.push({
					areas: ['zipcode'],
					text: `This product cannot be shipped internationally.`,
					highlight: 'warning'
				});
			}
		}

		// Check if the selected date is in the flex range
		let displayingFlexMessage = false;
		const selectedDate = this.getSelectedDate();
		if (selectedDate) {
			const flexSettings = this.getFlexSettingsForDateObj(new Date(selectedDate));
			if (flexSettings) {
				/* Don't display flex date message */
				/* messages.push({
					areas: ['datepicker'],
					text: flexSettings.text ? flexSettings.text : `This will be delivered during our Flex Holiday delivery period.`,
					highlight: 'normal'
				}); */
				messages.push({
					areas: ['calendar'],
					text: `This will be delivered during our Flex Holiday delivery period.`,
					highlight: 'normal'
				});
				displayingFlexMessage = true;
			}
		}

		// Check if delivery seasons apply
		if (this.deliverySeasons.length) {
			if (this.deliverySeasons.length == 1) {

				var startDateStr = new Date(this.deliverySeasons[0].start_date).toLocaleDateString();
				var endDateStr = new Date(this.deliverySeasons[0].end_date).toLocaleDateString();

				messages.push({
					areas: ['calendar', 'actions'],
					text: `This is a seasonal product that is available for delivery from ${startDateStr} to ${endDateStr} `,
					highlight: 'info'
				});
			} else {

				this.deliverySeasons.forEach((season, index) => {
					var startDateStr = new Date(season.start_date).toLocaleDateString();
					var endDateStr = new Date(season.end_date).toLocaleDateString();

					messages.push({
						areas: ['calendar', 'actions'],
						text: `This is a seasonal product that is available for delivery from ${startDateStr} to ${endDateStr} `,
						highlight: 'info'
					});
				});
			}
		}

		// Check if there are any rules
		if (this.rulesPayload) {
			for (const item of this.rulesPayload.rules) {

				// If the rule is a shipping cutoff rule, show the message as normal
				// unless a flex holiday is selected
				if (item.type === 'shipping cutoff' && !displayingFlexMessage) {

					// Is the selected date after today's date?
					// If so, skip the rule
					if (this.savedDeliveryDate && this.savedZipCode) {

						// Get the current time in the timezone
						// We only check timezones for domestic zips
						const timezone = KrempRules.getTimezoneForZipCode(this.savedZipCode);
						if (!timezone) {
							continue;
						}

						// Get the current time in the timezone
						let today = new Date().toLocaleString('en-US', { timeZone: timezone });
						today = new Date(today);
						today.setHours(0);
						today.setMinutes(0);
						today.setSeconds(0);

						// Get the selected date
						let selectedDate = new Date(this.savedDeliveryDate);
						selectedDate = new Date(selectedDate);
						selectedDate.setHours(0);
						selectedDate.setMinutes(0);
						selectedDate.setSeconds(0);

						// console.log(selectedDate, today);

						if (selectedDate > today) {
							continue;
						}
					}

					// If the zip code is not saved, show the message as normal
					if (!this.savedZipCode || !this.savedDeliveryDate) {
						// Logger.info(`${this.NAME} > getListOfAppliedRuleMessages > No zip code / date saved, show normal cutoff message`);
						// messages.push({
						// 	areas: ['calendar', 'datepicker'],
						// 	text: item.text,
						// 	highlight: 'warning'
						// });

						// If the cutoff time has passed, show the message as a warning
					} else if (KrempRules.isAfterCutOffTimeInZipCode(this.savedZipCode, this.savedDeliveryDate, item.time)) {
						// Logger.info(`${this.NAME} > getListOfAppliedRuleMessages > Cutoff time has passed, show warning cutoff message`);
						// messages.push({
						// 	areas: ['calendar', 'datepicker'],
						// 	text: `It is past the cutoff time for same-day delivery on this date.`,
						// 	highlight: 'warning'
						// });

						// If the cutoff time has not passed, show the message as normal
						// We only show this if the selected date is today

					} else {

						// Check if the selected date is today
						let today = new Date();
						today = today.toISOString().slice(0, 10);
						if (this.savedDeliveryDate && this.savedDeliveryDate === today) {
							Logger.info(`${this.NAME} > getListOfAppliedRuleMessages > Cutoff time has not passed, show normal cutoff message`);
							messages.push({
								areas: ['calendar', 'datepicker'],
								text: item.text,
								highlight: 'warning'
							});
						}
					}

					// If the rule is a checkout rule, show the message as normal
				} else if (item.type === 'checkout') {

					messages.push({
						areas: ['calendar', 'datepicker'],
						text: item.text,
						highlight: 'normal'
					});

					// If the rule is a warning, show the message as a warning
				} else if (item.type === 'warning') {

					Logger.info(`${this.NAME} > getListOfAppliedRuleMessages > Warning message`);

					// If there is a minimum price rule, only show the message if the price is less than the minimum price
					if (item.min_price) {
						if ((this.currentPrice / 100) < parseFloat(item.min_price)) {
							messages.push({
								areas: ['zipcode'],
								text: item.text,
								highlight: 'warning'
							});
						}

						// If the text contains "not available", show the message as a warning
					} else if (item.text.includes("not available")) {
						messages.push({
							areas: ['zipcode'],
							text: item.text,
							highlight: 'warning'
						});
					} else {
						messages.push({
							areas: ['zipcode'],
							text: item.text,
							highlight: 'normal'
						});
					}
				}
			}
		}
		return messages;
	}

	getSelectedDate() {
		this.selectedDate = localStorage.getItem('deliveryDate');

		if (!this.selectedDate || this.selectedDate === 'null') {
			return false;
		}

		return this.selectedDate;
	}

	/**
	 * initFlatpickr - Initialize the flatpickr calendar
	 */
	initFlatpickr() {
		Logger.info(`${this.NAME} > initFlatpickr`);

		if (this.flatpickrInput) return;

		var self = this;

		this.flatpickrInput = flatpickr("#flatpickrButton", {
			minDate: "today",
			maxDate: new Date().fp_incr(365),
			// dateFormat: "Y-m-d",
			dateFormat: "M d, Y",
			disableMobile: true,
			// onValueUpdate: function (selectedDates, dateStr, instance) {
			// 	// self.savedDeliveryDate = dateStr;
			// 	self.setSelectedDate(dateStr);
			// 	self.updateAllStatusMessages();
			// 	self.showCalendarPreviewArea();
			// },
			onChange: function (selectedDates, dateStr, instance) {
				Logger.info(`${self.NAME} > initFlatpickr > Change event > ${dateStr}`);
				if (dateStr && dateStr.length) {
					self.setSelectedDate(dateStr);
					self.updateAllStatusMessages();
					self.showCalendarPreviewArea();
				}
			},
			onDayCreate: function (dObj, dStr, fp, dayElem) {
				/* console.log(fp); */
				const flexSettings = self.getFlexSettingsForDateObj(dayElem.dateObj);
				if (flexSettings) {
					self.flexHolidayTooltipText = flexSettings.text ? flexSettings.text : `Orders placed within this period will be delivered as quickly as possible and may arrive on the selected date. Specific dates are not guaranteed.`;
					dayElem.className += " flex-holiday";
				}
			},
			onMonthChange: function (selectedDates, dateStr, instance) {
				self.updateCalendarLegend();
				const flexmsg = document.querySelector('[data-flex-msg]');
				if (flexmsg) {
					const flexdates = document.querySelectorAll('.flatpickr-day.flex-holiday');
					flexmsg.style.display = flexdates.length ? 'flex' : 'none';
				}
			},
			onOpen: function (selectedDates, dateStr, instance) {
				self.updateCalendarLegend();
				const flexmsg = document.querySelector('[data-flex-msg]');
				if (flexmsg) {
					const flexdates = document.querySelectorAll('.flatpickr-day.flex-holiday');
					flexmsg.style.display = flexdates.length ? 'flex' : 'none';
				}
			},
		});
	}

	/**
	 * isValidDate - Check if a date is valid
	 */
	isValidDate(dateStr) {
		const date = new Date(dateStr);

		// If the date is not a date object or is invalid
		// if (date instanceof Date && !isNaN(date)) {
		// 	Logger.error(`${this.NAME} > isValidDate > Invalid date: ${dateStr}`);
		// 	return false;
		// }

		// If the date is in the past
		let yesterday = new Date();
		yesterday.setDate(yesterday.getDate() - 1);
		if (date <= yesterday) {
			Logger.error(`${this.NAME} > isValidDate > Date is in the past: ${dateStr}`);
			return false;
		}

		// If there are cutoff times, check if the date is after the cutoff time
		// Check if there are any rules
		if (this.rulesPayload) {
			for (const item of this.rulesPayload.rules) {

				// If the rule is a shipping cutoff rule, show the message as normal
				// unless a flex holiday is selected
				if (item.type === 'shipping cutoff') {

					// Is the selected date after today's date?
					if (this.savedZipCode) {

						if (KrempRules.isAfterCutOffTimeInZipCode(this.savedZipCode, dateStr, item.time)) {
							Logger.error(`${this.NAME} > isValidDate > Date is after cutoff time: ${dateStr}`);
							return false;
						}

					}
				}
			}
		}

		return true;

	}

	/**
	 * setCalendarDays - Set the calendar days
	 */
	setCalendarDays() {

		Logger.info(`${this.NAME} > setCalendarDays`);

		const self = this;

		self.flatpickrFlexDates = [];
		self.flatpickrDisabledDates = [];
		self.flatpickrEnabledDates = [];

		self.deliverySeasons = [];

		// Check for delivery seasons
		if (this.savedZipCode && window.pdpDeliverySeasons) {

			// Loop through the seasons.
			// If the zip parameter is empty, assume its for all zips
			// If the zip parameter is not empty, check if the zip is in the list of zips
			// If the excluded zips parameter is not empty, check if the zip is not in the list of zips
			for (let s in window.pdpDeliverySeasons) {
				const season = window.pdpDeliverySeasons[s];

				// If there are no zips and the zip is not in the excluded zips, assume it is for all zips
				if (season.zips.length == 0 && !season.excluded_zips.includes(parseInt(this.savedZipCode))) {
					self.deliverySeasons.push(season);
					continue;
				}

				if (season.zips.length > 0 && season.zips.includes(parseInt(this.savedZipCode)) && !season.excluded_zips.includes(parseInt(this.savedZipCode))) {
					self.deliverySeasons.push(season);
					continue;
				}

			}
		}

		// Check for flex dates
		// Flex dates require a zip code to be saved
		if (this.savedZipCode) {
			this.flatpickrFlexDates = KrempRules.getFlexShippingDatesForZipCode(this.savedZipCode);
		}

		// Default Sunday to enabled
		this.flatpickrSundays = true;

		// Check for zip code rules
		if (this.rulesPayload) {
			for (const item of this.rulesPayload.rules) {

				// Apply rule based on type

				// Check if rule is a shipping cutoff
				if (item.type === 'shipping cutoff') {

					// We need to check cut off times, and then we are going to do various things with it

					// Find out if after todays cutoff time
					const today = new Date();
					const todayStr = today.toISOString().slice(0, 10);
					let afterCutoff = false;
					if (this.savedZipCode && todayStr && item.time != null) {
						afterCutoff = KrempRules.isAfterCutOffTimeInZipCode(this.savedZipCode, todayStr, item.time);
					}

					// Check if the rule has "unavailable same day"
					// If it does, we need to disable today no matter what, and if the cutoff time has passed, disable tomorrow
					if (item.same_day_unavailable === "true") {

						// 1. same day delivery is unavailable, no matter what
						const today = new Date();
						const todayStr = today.toISOString().slice(0, 10);
						this.flatpickrDisabledDates.push(todayStr);

						// 2. If the cutoff time has passed, disable tomorrow
						if (afterCutoff) {
							let tomorrow = new Date(today);
							tomorrow.setDate(today.getDate() + 1);
							this.flatpickrDisabledDates.push(tomorrow.toISOString().slice(0, 10));
						}

						// Otherwise, we only need to disable today if the cutoff time has passed for today
					} else {

						if (afterCutoff) {
							this.flatpickrDisabledDates.push(todayStr);
						}
					}
				}

				// Check if rule is Disabled Sundays
				if (item.type === 'disabled sunday') {
					this.flatpickrSundays = false;
				}

			}

		} else {

			// Calendar Settings
			// console.log('Set default calendar settings');

			// disable today
			const today = new Date();

			// disable tomorrow
			let tomorrow = new Date(today);
			tomorrow.setDate(today.getDate() + 1);

			// disable day after tomorrow
			let dayAfterTomorrow = new Date(today);
			dayAfterTomorrow.setDate(today.getDate() + 2);

			this.flatpickrDisabledDates.push(today.toISOString().slice(0, 10));
			this.flatpickrDisabledDates.push(tomorrow.toISOString().slice(0, 10));
			this.flatpickrDisabledDates.push(dayAfterTomorrow.toISOString().slice(0, 10));

			// disable all Sundays
			this.flatpickrSundays = false;
		}

		// If there are delivery seasons, then we need to whitelist the enabled dates
		if (this.deliverySeasons.length > 0) {

			Logger.info(`${this.NAME} > setCalendarDays > Delivery seasons found, setting up calendar with delivery seasons`);

			// reset flatpickrEnabledDates just in case
			this.flatpickrEnabledDates = [];

			// populate flatpickrEnabledDates
			for (let s in this.deliverySeasons) {
				const season = this.deliverySeasons[s];
				this.flatpickrEnabledDates = this.flatpickrEnabledDates.concat(this.generateDateRange(season.start_date, season.end_date));
			}

			// set up calendar with delivery seasons, enabling only the dates in the delivery seasons
			this.flatpickrInput.set({
				enable: [
					function (date) {

						// Get date string from date of YYYY-MM-DD
						let date_str = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

						if (self.flatpickrSundays == false && date.getDay() === 0) {
							return false;
						}
						if (self.flatpickrDisabledDates.includes(date_str)) {
							return false;
						}
						if (self.flatpickrEnabledDates.includes(date_str)) {
							return true;
						}
					}
				]
			});

			// If there are no delivery seasons, then we need to blacklist the disabled dates
		} else {

			Logger.info(`${this.NAME} > setCalendarDays > No delivery seasons found, setting up calendar with disabled dates`);

			// set up calendar with no seasons, just whatever specific days are disabled.
			this.flatpickrInput.set({
				enable: [
					function (date) {
						let date_str = date.toISOString().slice(0, 10);
						if (self.flatpickrSundays == false && date.getDay() === 0) {
							return false;
						}
						if (self.flatpickrDisabledDates.includes(date_str)) {
							return false;
						}
						// If there is a cutoff rule
						if (self.rulesPayload && self.savedZipCode) {
							for (const item of self.rulesPayload.rules) {
								if (item.type === 'shipping cutoff') {
									if (KrempRules.isAfterCutOffTimeInZipCode(self.savedZipCode, date_str, item.time)) {
										return false;
									}
								}
							}
						}
						return true;
					}
				]
			});
		}
	}

	setSelectedDate(dateStr) {
		Logger.info(`${this.NAME} > setSelectedDate > ${dateStr}`);

		if (!dateStr) {
			Logger.error(`${this.NAME} > setSelectedDate > Clearing selected date`);
			this.savedDeliveryDate = false;
			localStorage.removeItem('deliveryDate');
			this.showCalendarInputArea();
			return;
		} else {

			this.savedDeliveryDate = dateStr;
			localStorage.setItem('deliveryDate', dateStr);
			// console.log('Date saved:', dateStr);
		}

		// Fire event
		this.trigger('on:date:update', { date: dateStr });
	}

	setActionMessage(msg, type) {
		if (!this.actionMessageDoms.length) {
			return;
		}

		if (!type) type = 'normal';

		this.actionMessageDoms.forEach((dom) => {
			dom.innerHTML += `<div${type ? ' class="action-msg--' + type + '"' : ''}>${msg}</div>`;
		});
	}

	setDatePickerMessage(msg, type) {
		if (!this.datePickerMessageDoms.length) {
			return;
		}

		if (!type) type = 'normal';

		this.datePickerMessageDoms.forEach((dom) => {
			dom.innerHTML += `<div${type ? ' class="date-picker-msg--' + type + '"' : ''}>${msg}</div>`;
		});
	}

	setZipCodeMessage(msg, type) {
		if (!this.zipCodeMsgDoms.length) {
			return;
		}

		if (!type) type = 'normal';

		this.zipCodeMsgDoms.forEach((dom) => {
			dom.innerHTML += `<div${type ? ' class="zip-code-msg--' + type + '"' : ''}>${msg}</div>`;
		});
	}

	// Show Calendar Preview Area
	showCalendarPreviewArea() {
		this.calendarInputArea.style.display = 'none';
		this.calendarPreviewArea.style.display = 'flex';
		this.enforcePurchasability(true);
	}

	// Show Calendar Input Area
	showCalendarInputArea() {
		this.calendarInputArea.style.display = 'flex';
		this.calendarPreviewArea.style.display = 'none';
		this.enforcePurchasability(true);
	}

	// Show Zip Code Preview Area
	showZipCodePreviewArea() {
		this.zipCodeInputArea.style.display = 'none';
		this.zipCodePreviewArea.style.display = 'flex';
		this.enforcePurchasability(true);
	}

	// Show Zip Code Input Area
	showZipCodeInputArea() {
		this.zipCodeInputArea.style.display = 'flex';
		this.zipCodePreviewArea.style.display = 'none';
		this.enforcePurchasability(true);
	}

	updateCalendarLegend() {

		this.flatpickrInput.rContainer.querySelector('.flatpickr-notes')?.remove();
		this.flatpickrInput.rContainer.querySelector('.flatpickr-legend')?.remove();

		const messages = this.getListOfAppliedRuleMessages();

		// Get all messages for date picker
		const datePickerMessages = messages.filter(message => message.areas.includes('calendar'));

		const legendHtml = `
			${datePickerMessages.length ? '<div class="flatpickr-notes">' : ''}
				${datePickerMessages.map(message => `<div class="flatpickr-note flatpickr-note--${message.highlight}">${message.text}</div>`).join('')}
			${datePickerMessages.length ? '</div>' : ''}
			<div class="flatpickr-legend">
				<div class="flatpickr-legend__item flatpickr-legend__item--available">
					<span></span> Available
				</div>
				<div class="flatpickr-legend__item flatpickr-legend__item--selected">
					<span></span> Selected
				</div>
				<div class="flatpickr-legend__item flatpickr-legend__item--unavailable">
					<span></span> Not Available
				</div>
				${this.flexHolidayTooltipText !== null ? '<div class="flatpickr-legend__item flatpickr-legend__item--flex" data-flex-msg><span></span> Flex Holiday Delivery<div class="flatpickr-legend__item-tooltip">' + this.flexHolidayTooltipText + '</div></div>' : ''}
			</div>
			`;

		this.flatpickrInput.rContainer.insertAdjacentHTML('beforeend', legendHtml);
	}

	updateAllStatusMessages() {
		Logger.info(`${this.NAME} > updateAllStatusMessages`);

		const selectedDate = this.getSelectedDate();

		// Set the selected date
		if (this.savedDeliveryDate) {
			this.dom.querySelector('#selectedCalendarDate').innerText = this.savedDeliveryDate.replace(/(\d{4})-(\d{2})-(\d{2})/, '$2/$3/$1');
		}

		const messages = this.getListOfAppliedRuleMessages();

		// ACTION AREA MESSAGES
		// These go under the CTA buttons
		this.clearActionMessages();
		for (const message of messages) {
			if (message.areas.includes('actions')) {
				this.setActionMessage(message.text, message.highlight);
			}
		}

		// ZIP CODE MESSAGES
		// These go under the zip code input
		this.clearZipCodeMessages();
		for (const message of messages) {
			if (message.areas.includes('zipcode')) {
				this.setZipCodeMessage(message.text, message.highlight);
			}
		}

		// DATE PICKER MESSAGES
		// These go under the date picker
		this.clearDatePickerMessages();
		for (const message of messages) {
			console.log('message', message);
			if (message.areas.includes('datepicker')) {
				this.setDatePickerMessage(message.text, message.highlight);
			}
		}
	}

}

Object.assign(ZipInCal.prototype, event);

export default ZipInCal;
